<script>
    import { onMount } from 'svelte'; 
    import { push } from 'svelte-spa-router';
    import '@assets/styles/admin.css';
    import { login } from '@lib/api/auth.js';

    let userId = '';
    let password = '';
    let error = '';
    let rememberId = true;

  const handleLogin = async () => {
    error = '';
    try {
      await login({ user_id: userId, password });
      
      if (rememberId) {
        localStorage.setItem('savedUserId', userId);
      } else {
        localStorage.removeItem('savedUserId');
      }

      push('/dashboard');
    } catch (err) {
      error = err.message || '로그인 실패';
    }
  };

    
   onMount(() => {
      console.log(`${import.meta.env.VITE_API_BASE}`)
      const savedId = localStorage.getItem('savedUserId');
      if (savedId) {
        userId = savedId;
        rememberId = true;
      }
    });

</script>

<div class="wrap">
  <section class="container">
    <section class="content">
      <div class="login-wrap">
        <div class="login-cont">
          <div class="login-cont__inner">
            <div class="d-flex align-center">
              <div class="login-logo text-center">
                <span class="img-wrap">
                  <img src="{`${import.meta.env.BASE_URL}image/img-logo.png`}" alt="4seasonAI 출재쌤" />
                </span>
              </div>

              <div class="login-cont-top">
                <p class="login-title"><strong>출제쌤</strong> 관리시스템</p>

                <form class="d-flex align-center flex-wrap gap-3 mt-6" on:submit|preventDefault={handleLogin}>
                  <fieldset class="w-100">
                    <legend>아이디 input 텍스트</legend>
                    <label for="input-field-login-id">
                      <input
                        id="input-field-login-id"
                        class="input-field"
                        placeholder="아이디를 입력하세요"
                        bind:value={userId}
                      />
                    </label>
                  </fieldset>

                  <fieldset class="w-100">
                    <legend>비밀번호 input 텍스트</legend>
                    <label for="input-field-login-password">
                      <input
                        type="password"
                        id="input-field-login-password"
                        class="input-field"
                        placeholder="비밀번호를 입력하세요"
                        bind:value={password}
                      />
                    </label>
                  </fieldset>

                  <fieldset>
                    <legend>id저장 input 체크 박스</legend>
                    <div class="d-flex align-center">
                      <div class="custom-checkBox">
                        <input type="checkbox" id="input-field-saveId" bind:checked={rememberId} />
                        <label for="input-field-saveId">
                          <span>id 저장 체크박스</span>
                        </label>
                      </div>
                      <p class="ml-2 font-13">아이디저장</p>
                    </div>
                  </fieldset>

                  <button type="submit" class="btn btn-login mt-3">로그인</button>
                </form>
              </div>
            </div>

            <div class="login-rights">
              <p class="mt-18 font-12 color-grey-500 text-center">
                본 시스템은 Microsoft Edge 및 Chrome 환경에 최적화 되어 있습니다.
              </p>
              <p class="mt-2 font-12 color-grey-500 text-center">
                COPYRIGHT © 4SEASON AI. ALL RIGHTS RESERVED.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</div>